export default {
  notificationChannels: 'Notification Channels',
  userSubscription: 'User subscriptions',
};
